import Vue from 'vue';

export default (warehouse = null) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/shipping_providers/warehouse_shipping_provider/${warehouse}`)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/shippingProvider/warehouseShippingProvider.js